import Resource from 'Resources/Resource';
import LabelModel from './Model/Label';

export type LabelStats = {
	/** doc_count keyed by label id, over the filtered entity set. */
	byLabelId: Record<number, number>;
	/** Total entities matching the (non-label) filters. */
	total: number;
	/** Entities in `total` that carry no label. */
	unlabeled: number;
};

class Label extends Resource {
	constructor() {
		super('labels');
	}

	/**
	 * SQL-backed label counts for an entity, respecting the supplied list
	 * filters. Single code path for every label-supporting entity (ES- or
	 * SQL-backed) — see the `/labels/stats` controller.
	 */
	stats(entity: LabelModel['entity'], query: Record<string, unknown>): Promise<LabelStats> {
		return this._getRequest('stats', { params: { ...query, entity }, methodName: 'stats' }).then(
			(res: { data: { data: LabelStats } }) => res.data.data
		);
	}
}

const resource = new Label();

export default resource;
